class RequestService {
    // async function
    async getRequest(url, where) {

        console.log(where);
        const data = await fetch(url).then((res) => {

            if (res.status === 204) {
                return {}
            }
            let json = res.json(); // there's always a body
            if (res.status >= 200 && res.status < 300) {
                return json;
            }
            return json.then(Promise.reject.bind(Promise));

        })
            .catch((err) => {
                console.log("Error: ", err);
                return Promise.reject();
            });

        return data;
    }

    async postRequest(url, filter) {
        const data = await fetch(url, {
            method: "POST",
            body: JSON.stringify(filter),
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((res) => {
                let json = res.json(); // there's always a body
                if (res.status >= 200 && res.status < 300) {
                    return json;
                }
                return json.then(Promise.reject.bind(Promise));

            })
            .catch((err) => {
                console.log("Error: ", err);
                return Promise.reject();
            });
        return data;
    }
}

export default new RequestService();
